import { NotificationKeyValueMap } from '@model';
import { ParsedStorageDataType } from '@utils/localStorage';

export { LIVE_FEATURE_ENABLED, isLiveFeatureEnabled } from './live';

export const enum ChatieErrorCode {
  ItemAlreadyPurchasedError = 'ItemAlreadyPurchasedError',
  PaidTapShortageError = 'PaidTapShortageError',
  NotAuthenticated = 'NotAuthenticated',
  PermissionDenied = 'PermissionDenied',
  AuthenticationTokenError = 'AuthenticationTokenError',
  CertificationExpiredError = 'CertificationExpiredError',
  CharacterCreativeError = 'CharacterCreativeError',
  GuestFreeMessageExhausted = 'GuestFreeMessageExhausted',
}

export const SUBSCRIPTION_GRADIENT_COLOR = `linear-gradient(90deg, #12C2E9 0%, #C471ED 42.48%, #F64F59 95.45%)`;
export const PASS_GRADIENT_COLOR = `linear-gradient(55.29deg, #FF07F5 20.46%, #ED0064 82.76%);`;
// export const AOS_SUBSCRIBE_ITEM_ID = (isProduction: boolean) =>
//   isProduction ? 74 : 70;
// export const AOS_PASS_ITEM_ID = (isProduction: boolean) =>
//   isProduction ? 77 : 72;

// export const AOS_SUBSCRIBE_ITEM_BUNDLE_ID = (isProduction: boolean) =>
//   isProduction ? 'me.chatie.sub.play_box' : 'me.chatie_dev.sub.play_box';

// export const AOS_PASS_BUNDLE_ID = (isProduction: boolean) =>
//   isProduction
//     ? 'me.chatie.bundle_pass.play_pass'
//     : 'me.chatie_dev.bundle_pass.play_pass';

export const SUBSCRIBE_ITEM_ID = (isProduction: boolean, isIos: boolean) =>
  isProduction ? (isIos ? 76 : 74) : isIos ? 71 : 70;
export const PASS_ITEM_ID = (isProduction: boolean, isIos: boolean) =>
  isProduction ? (isIos ? 78 : 77) : isIos ? 76 : 72;

export const SUBSCRIBE_ITEM_BUNDLE_ID = (
  isProduction: boolean,
  isIos: boolean
) =>
  isProduction
    ? isIos
      ? 'me.chatie.sub.play_box.basic'
      : 'me.chatie.sub.play_box'
    : isIos
    ? 'me.chatie_dev.sub.play_box.basic'
    : 'me.chatie_dev.sub.play_box';

export const PASS_BUNDLE_ID = (isProduction: boolean, isIos: boolean) =>
  isProduction
    ? isIos
      ? 'me.chatie.bundle_pass.play_pass'
      : 'me.chatie.bundle_pass.play_pass'
    : isIos
    ? 'me.chatie_dev.bundle_pass.play_pass'
    : 'me.chatie_dev.bundle_pass.play_pass';

export const SUBSCIRBE_VERSION = {
  iOS: '2.26.5',
  android: '2.33.0',
};

export const SUBSCIRBE_TEAR_VERSION = {
  iOS: '10.26.5',
  android: '10.33.12',
};

export const ADX_REWARD_VERSION = {
  iOS: '2.29.3',
  android: '2.34.0',
};

export const enum StoryType {
  standard = 'standard',
  original = 'original',
  bloom = 'bloom',
}

export const enum SubscriptionState {
  pending = 'PENDING',
  paused = 'PAUSED',
  inProgress = 'IN_PROGRESS',
  inGracePeriod = 'IN_GRACE_PERIOD',
  onHold = 'ON_HOLD',
  canceled = 'CANCELED',
  expired = 'EXPIRED',
}

export const enum ProductType {
  subs = 'subs',
  inapp = 'inapp',
}

export const enum StoryTheme {
  tapNovel = 'tap_novel',
  iknow = 'iknow',
}

export const enum StorySaleType {
  standard = 'S',
  standardWaitfree = 'SWF',
}

export const enum StoryWaitfreeStatus {
  active = 'AT',
  inactive = 'IAT',
}

export const enum StoryAdType {
  list = 'LIST',
  full = 'FULL',
}

export const enum StoryAdCreativeType {
  episodePlayer = 'episode_player',
  aiVerticalVideo = 'ai_vertical_video',
}

export const enum StoryAdCreativeStatus {
  ready = 'READY',
}

export const enum StoryAdVideoGenerationStatus {
  requested = 'REQUESTED',
  processing = 'PROCESSING',
  succeeded = 'SUCCEEDED',
  failed = 'FAILED',
  canceled = 'CANCELED',
}

export const enum EpisodeStatus {
  private = 'private',
  review = 'review',
  reject = 'reject',
  public = 'public',
  prePublic = 'pre_public',
  bookedPublic = 'booked_public',
}

export const enum CommentObjectType {
  story = 'story',
  episode = 'episode',
  storyToonEpisode = 'story_toon_episode',
  post = 'community',
  comment = 'comment',
  chatRoom = 'chat_room',
}

export const enum CommentType {
  general = 'general',
  best = 'best',
  fixed = 'fixed',
}

export const enum CommentFormType {
  all = 'all',
  common = 'common',
  paid = 'paid',
}

export const enum CommentCustomType {
  donation = 'donation',
  preview = 'preview',
  rental = 'rental',
  possession = 'possession',
}

export const enum ShareType {
  web = 'web',
  app = 'app',
}

export const enum Platform {
  android = 'aos',
  ios = 'ios',
  web = 'web',
}

export const enum VoucherEffectType {
  /**
   * 풍선 N개 추가 바우처
   */
  abfs = 'AB_F_S',
  /**
   * 결재 시, 풍선 N% 추가 바우처
   */
  abpfp = 'ABP_F_P',
  /**
   * 후원 시, 풍선 N% 추가 바우처
   */
  abpfr = 'ABP_F_R',
  /**
   * 후원 시, 풍선 N% 할인 바우처
   */
  dbpfd = 'DBP_F_D',
  /**
   * 작품 홍보 시, 풍선 N% 할인 바우처
   */
  dbpfsa = 'DBP_F_SA',
  /**
   * 작품 홍보 시, 풍선 N개 할인 바우처
   */
  dbnfsa = 'DBN_F_SA',
  /**
   * 회차 데이터 조회 시, 풍선 N% 할인 바우처
   */
  dbpfes = 'DBP_F_ES',
  /**
   * 회차 예약 시, 풍선 N% 할인 바우처
   */
  dbpfeb = 'DBP_F_EB',
  /**
   * 회차 먼저보기 시, 풍선 N% 할인 바우처
   */
  dbpfep = 'DBP_F_EP',
  /**
   * 회차 대여 바우처
   */
  dbpfer = 'DBP_F_ER',
  /**
   * 회차 소장 바우처
   */
  dbpfeps = 'DBP_F_EPS',

  all = 'ALL',
  storyAds = 'ALL_STORY_ADS',
  donation = 'ALL_DONATION',
  reward = 'ALL_REWARD',
  payment = 'ALL_PAYMENT',
  booking = 'ALL_EPISODE_BOOKED',
  preview = 'ALL_EPISODE_PREVIEW',
  rental = 'ALL_EPISODE_RENTAL',
  possession = 'ALL_EPISODE_POSSESSION',
  purchase = 'ALL_EPISODE_PURCHASE', // 대여 + 소장
}

export const enum VoucherPeriodType {
  oneTime = 'OT',
  limitedTime = 'LT',
}

export const enum VoucherRecommendationType {
  payment = 'PAYMENT',
  reward = 'REWARD',
  storyAd = 'STORY_ADS',
  donation = 'DONATION',
  statistic = 'EPISODE_STATISTIC',
  booking = 'EPISODE_BOOKED',
  preview = 'EPISODE_PREVIEW',
  rental = 'EPISODE_RENTAL',
  possession = 'EPISODE_POSSESSION',
  market = 'MARKET_ITEM_PURCHASE',
}

export const enum UniversalReason {
  closeUser = 'close_user',
  lowReview = 'low_review',
  requestCategory = 'req_category',
  appReview = 'app_review',
  storyAdReview = 'story_ad_review',
  unregisterUser = 'close_user',
}

export enum MarketItemType {
  profileBg = 'skin_profile_bg',
  profileBtn = 'skin_profile_btn',
  comment = 'skin_comment_card',
  userPicture = 'skin_user_picture',
  userNickname = 'skin_user_nickname',
  etc = 'etc',
  curation = 'curation', // ui only
}

export const enum CurationType {
  originalTabRecommend = 'OTR',
  standardTabRecommend = 'STR',
}

export const enum CurationMoreType {
  container = 'CTN',
}

export const enum CurationViewType {
  waitfree = 'WF',
  chatiePick = 'CP',
  storyRanking = 'SR',
  realtimeRanking = 'RR',
  recentStory = 'RS',
  userRanking = 'UR',
  liveUser = 'LU',
  honorUser = 'HU',
}

export const enum SectionType {
  standard = 'ST',
  standardRecommend = 'STR',
  original = 'OT',
  etc = 'ETC',
}

export const enum StoryAdStatus {
  ready = 'READY',
  progress = 'PROGRESS',
  canceled = 'CANCELED',
  done = 'DONE',
  rejected = 'REJECTED',
}

export enum RestrictionStatus {
  normal = 'NORMAL',
  caution = 'CAU',
  warn1 = 'WARN_1',
  warn2 = 'WARN_2',
  warn3 = 'WARN_3',
  warn4 = 'WARN_4',
  exception = 'EXC',
}

export const enum CheerType {
  donation = 'DON',
  preview = 'PREV',
  ad = 'AD',
  normal = 'ST',
}

export const enum TabIndex {
  home,
  original,
  search,
  library,
  studio,
}

export const enum CertificationType {
  phone = 'PL',
  adult = 'AC',
}

export const enum StoryAgeGrade {
  all = 'G',
  adult = 'X',
}

export const enum NoticeCategory {
  service = 'SRV',
  event = 'EVT',
  policy = 'POLY',
}

export const enum WithdrawalStatus {
  request = 'REQ',
  success = 'SUC',
  fail = 'FAI',
  progress = 'PRO',
}

export const enum EpisodePurchaseType {
  waitfree = 'waitfree',
  showAd = 'show_ad',
  removeAd = 'remove_ad',
  rental = 'rental',
  possession = 'possession',
  preview = 'preview',
  storyPass = 'story_pass',
}

export const enum SettingType {
  user = 'user',
  story = 'story',
  comment = 'comment',
  playCharacter = 'play_character',
}

export const enum ReportObjectType {
  user = 'user',
  episode = 'episode',
  community = 'community',
  comment = 'comment',
  character = 'character',
  character_community = 'character_community',
  chatRoom = 'chat_room',
  liveEvent = 'live_event',
}

export const enum EpisodeReadFrom {
  cta = 'cta',
  list = 'list',
}

export const enum PurchaseType {
  A = 'A',
  OFP = 'OFP',
  EFP = 'EFP',
  OTP = 'OTP',
}

export { QUERY_KEYS } from './query';
export {
  STORY_TOON_STORY_ENTRY_ENABLED,
  WEBTOON_EPISODE_LIST_LIMIT,
  WEBTOON_STORIES,
  WEBTOON_STORY_TOON_IDS,
  isStoryToonStoryEntryEnabled,
} from './webtoon';
export type { WebtoonStoryMeta } from './webtoon';

export const NOTI_TYPE = {
  STORE_ENABLE: 'store-enable',
  STORE_DISABLE: 'store-disable',

  EVENT_ENABLE: 'event-enable',
  EVENT_DISABLE: 'event-disable',

  RECOMMEND_ENABLE: 'recommend-enable',
  RECOMMEND_DISABLE: 'recommend-disable',

  ORIGINAL_ENABLE: 'original-enable',
  ORIGINAL_DISABLE: 'original-disable',

  BEST_ENABLE: 'best-enable',
  BEST_DISABLE: 'best-disable',

  ETC_ENABLE: 'etc-enable',
  ETC_DISABLE: 'etc-disable',

  FOLLOW_ENABLE: 'follow-enable',
  FOLLOW_DISABLE: 'follow-disable',

  FOLLOW_UPDATE_ENABLE: 'follow-update-enable',
  FOLLOW_UPDATE_DISABLE: 'follow-update-disable',

  LIVE_ENABLE: 'live-enable',
  LIVE_DISABLE: 'live-disable',

  COMMENT_ENABLE: 'comment-enable',
  COMMENT_DISABLE: 'comment-disable',

  REPLY_ENABLE: 'reply-enable',
  REPLY_DISABLE: 'reply-disable',

  LIKE_ENABLE: 'like-enable',
  LIKE_DISABLE: 'like-disable',

  STORY_ENABLE: 'story-enable',
  STORY_DISABLE: 'story-disable',

  DONATION_ENABLE: 'donation-enable',
  DONATION_DISABLE: 'donation-disable',

  AD_ENABLE: 'ad-enable',
  AD_DISABLE: 'ad-disable',

  EPISODE_ENABLE: 'episode-enable',
  EPISODE_DISABLE: 'episode-disable',

  WAIT_FREE_ENABLE: 'wait-free-enable',
  WAIT_FREE_DISABLE: 'wait-free-disable',

  PROMO_ENABLE: 'promo-enable',
  PROMO_DISABLE: 'promo-disable',

  NEW_CHATBOT_ENABLE: 'chatbot-enable',
  NEW_CHATBOT_DISABLE: 'chatbot-disable',

  PLAY_GROUND_ENABLE: 'playground-enable',
  PLAY_GROUND_DISABLE: 'playground-disable',
} as const;

type NotiKey = {
  [key: string]: keyof NotificationKeyValueMap;
};

export const NOTI_KEY: NotiKey = {
  //story
  STORY: 'setting__push__co__my_story',
  DONATION: 'setting__push__co__cheer',
  AD: 'setting__push__co__ad',
  EPISODE: 'setting__push__co__new_episode',
  WAITFREE: 'setting__push__co__waitfree',

  //play
  NEW_CHATBOT: 'setting__push__play__new_chatbot',
  PLAY_GROUND: 'setting__push__play__ground',

  //comment
  COMMENT: 'setting__push__co__new_comment',
  REPLY: 'setting__push__co__new_reply',
  LIKE: 'setting__push__co__comment_like',

  //chatie
  RECOMMEND: 'setting__push__global__reco',
  ORIGINAL: 'setting__push__global__new_original',
  BEST: 'setting__push__global__new_best',
  EVENT: 'setting__push__global__event',
  ETC: 'setting__push__global__etc',

  //event
  PROMO: 'setting__eos__etc__promo',

  //follow
  FOLLOW: 'setting__push__rel__follow',
  FOLLOW_UPDATE: 'setting__push__rel__new_co',
  LIVE: 'setting__push__rel__live',

  //store
  STORE: 'setting__push__store__market_item_expire',

  //index
  PAUSE: 'setting__push__global__paused_at',
};

export const DATA_TEST = {
  EMPTY: 'empty',
  SWITCH: 'switch',
  NOTI_SETTING: {
    RADIO_LABEL: (value: string) => `${value}-label`,
  },
};

export const CUSTOMER_CENTER_URL = 'https://help.chatie.me/hc/ko';
export const COMMUNITY_GUIDELINE_PATH = '/community-guide.html';
export const COMMUNITY_GUIDELINE_URL = `${process.env.NEXT_PUBLIC_DOMAIN}${COMMUNITY_GUIDELINE_PATH}`;
export const HONOR_NOTION_URL =
  'https://eineblume.notion.site/2024-6bdc2cb23ce343519c7e021ec92ddad2';

export const CHECK_SIGN_KEY = {
  NICKNAME: 'nickname',
  EMAIL: 'signup_by_email',
  facebook: 'signup_by_facebook',
  kakao: 'signup_by_kakao',
  naver: 'signup_by_naver',
  google: 'signup_by_google',
  apple: 'signup_by_apple',
};

export const CHAT_TYPE = {
  SENDER: 'sender',
  GENERAL: 'general',
  RECEIVER: 'receiver',
  NARRATION: 'narration',
} as const;

export const INITIAL_GENERAL_BUBBLE_STYLE = {
  bubbleColor: 'transparent',
  textColor: '5B5B5B',
  textAlign: 'center',
  textStyle: 'initial',
  fontWeight: 'bold',
  wordBreak: 'normal',
  fontFamily: '',
};

type ParsedStorageValueKeys = keyof ParsedStorageDataType;

export const PARSED_STORAGE_KEY: Record<string, ParsedStorageValueKeys> = {
  IS_SKIP_FREE_CHAT: 'isSkipFreeChat',
  HAS_USED_CHAT_INTRO: 'hasUsedChatIntro',
  HAS_USED_PAID_CHAT: 'hasUsedPaidChatv2',
  HAS_USED_FREE_CHAT: 'hasUsedFreeChat',
  HAS_USED_FREE_CHAT_PER_UUID: 'hasUsedFreeChatPerUUIDv2',
  HAS_SEND_FREE_CHAT_PER_UUID: 'hasSendFreeChatPerUUIDv2',
  SHOWN_CHAT_STORY_IDS: 'shownChatStoryIds',
  HAS_ARRIVED_TUTORIAL: 'hasArrivedTutorial',
};

export const SD_API_URL = {
  staging: `${process.env.NEXT_PUBLIC_CHAT_BOT_API_URL}/v2/chatie-scene-background-images`,
  production: `${process.env.NEXT_PUBLIC_CHAT_BOT_API_URL}/v2/chatie-scene-background-images`,
};

export const CHARACTER_FORM_WORDS_LIMIT = {
  NAME: 20,
  GREETING: 20,
  JOB: 20,
  PERSONALITY: 200,
  APPEARANCE: 100,
  TONE_OF_VOICE: 100,
  CHARACTERISTICS: 100,
  RELATIONSHIP: 100,
  START_MESSAGE: 500,
  FIRST_MESSAGE_SELECT: 100,
  CHAPTER_FIRST_MESSAGE: 300,
  CHAPTER_TITLE: 30,
  CHAPTER_DESCRIPTION: 10000,
};

export const CHEMING_CHARACTER_FORM_WORDS_LIMIT = {
  NAME: 20,
  GREETING: 20,
  JOB: 40,
};

export enum PAYMENT_VENDOR {
  standard = 'S',
  apple = 'A',
  z = 'Z',
}

export const BANK_LIST = [
  '카카오뱅크',
  '토스뱅크',
  'NH농협은행',
  '우리은행',
  'KB국민은행',
  '신한은행',
  '하나은행',
  'IBK기업은행',
  'DGB대구은행',
  '새마을금고',
  '부산은행',
  '신협',
  '케이뱅크',
  '경남은행',
  '광주은행',
  '전북은행',
  '제주은행',
  '씨티은행',
  '홍콩상하이은행',
  'KDB산업은행',
  'SC제일은행',
  'Sh수협은행',
];

export enum SECTION_STORY_TYPE {
  standard = 'ST',
}

export const PLAYSTORE_PAYMENT_TEXT = [
  '[Google Play 결제 안내]',
  '결제는 현재 사용하고 있는 Google Play 로그인 계정으로 진행됩니다. ',
  '결제가 완료되기 전에 결제창을 닫으면 결제가 완료되지 않을 수 있습니다.',
  '정기 결제는 매월 동일한 날짜에 자동으로 정기 결제가 이루어집니다.',
  '정기 결제를 취소할 경우 남은 기간에 대한 요금 환불은 불가능하며, 다음 정기 결제부터 취소가 적용됩니다.',
  '결제 금액에 대한 확인은 Google Play 스토어에서 가능하며 결제/취소/환불정책은 Google Play 정책이 적용됩니다.',
  '정기 결제 취소는 [Google Play 스토어 - 정기 결제]에서 가능합니다.',
  '채티 앱을 삭제하거나 회원 탈퇴를 하더라도 자동으로 정기 결제 취소가 되지 않으니, 서비스 이용을 원치 않으실 경우 Google Play 스토어에서 정기 결제를 취소해주세요.',
  '상품 가격은 부가가치세와 수수료가 포함된 가격입니다.',
  '결제에 따른 개인정보는 ‘개인정보처리방침’에 의거하여 관리됩니다.',
  '관련 문의는 help@eineblu.me 이메일로 문의해주시기 바랍니다.',
];

export const APPSTORE_PAYMENT_TEXT = [
  '[App Store 결제 안내]',
  '결제는 사용자의 Apple ID를 통해 처리되며, 구매가 확인되면 즉시 결제됩니다.',
  '결제가 완료되기 전에 결제창을 닫으면 결제가 완료되지 않을 수 있습니다.',
  '정기 결제는 매월 동일한 날짜에 자동으로 정기 결제가 이루어집니다.',
  '결제 금액은 부가세(VAT) 및 Apple 수수료가 포함되어 있으며, 해외 원화 결제(DCC)에 따른 추가 수수료가 발생할 수 있습니다.',
  '사용자는 설정 > Apple ID 설정에서 구독을 관리하거나 취소할 수 있습니다.',
  '구독을 취소하더라도 청구 기간이 끝날 때까지 서비스에 접근할 수 있습니다. 그러나 이후에는 자동 갱신이 중단됩니다.',
  '채티 앱을 삭제하거나 회원 탈퇴를 하더라도 자동으로 정기 결제 취소가 되지 않으니, 서비스 이용을 원치 않으실 경우 설정 > Apple ID 설정에서 정기 결제를 취소해주세요.',
  '결제에 따른 개인정보는 ‘개인정보처리방침’에 의거하여 관리됩니다.',
  '관련 문의는 help@eineblu.me 이메일로 문의해주시기 바랍니다.',
];

export enum OUTLOOK_PAGE {
  home = 'home',
}
export enum EVENT_TYPE {
  daily = 'daily',
  newUser = 'newUser',
}

export const SHOW_AD_TAP_COUNT = 400;

export enum AchievementRequirement {
  adReward = 'AD_REWARDED_TODAY',
  playShare = 'PLAY_SHARE',
  invitation = 'INVITATION',
  verification = 'PHONE_CERTIFICATION',
}

export enum SelfiePollStatus {
  PD = 'PD',
  PG = 'PG',
  CP = 'CP',
  FL = 'FL',
}

export enum OmniType {
  text = 'text',
  visual_selfie = 'visual_selfie',
  visual_selfie_request = 'visual_selfie_request',
}

export const VISUAL_CREATE_BALLOON = 199;

export enum CHAT_ROOM_ENV {
  GUEST = 'guest',
  ADULT = 'adult',
  NORMAL = 'normal',
}

export const PAYMENT_METHODS = (isProduction = true) => {
  return {
    card: {
      pg: isProduction ? 'danal_tpay.A010052737' : 'danal_tpay.9810030929',
      pay_method: 'card',
    },
    trans: {
      pg: 'danal_tpay',
      pay_method: 'trans',
    },
    vbank: {
      pg: 'danal_tpay',
      pay_method: 'vbank',
    },
    phone: {
      pg: 'danal_tpay',
      pay_method: 'phone',
    },
    kakaopay: {
      pg: isProduction ? 'kakaopay.CA00005579' : 'kakaopay.TC0ONETIME',
    },
  };
};

export const BANNED_USER_ERROR = 'BannedUserError';

export const DUPLICATED_ERROR = 'DuplicatedError';

export const SOCIAL_LOGIN_ERROR = 'SocialLoginError';
export const FACEBOOK_LOGIN_ERROR = 'FacebookLoginError';
export const KAKAO_LOGIN_ERROR = 'KakaoLoginError';
export const NAVER_LOGIN_ERROR = 'NaverLoginError';
export const GOOGLE_LOGIN_ERROR = 'GoogleLoginError';
export const APPLE_LOGIN_ERROR = 'AppleLoginError';
export const USER_NOT_FOUND = 'UserNotFoundError';

export const NAV_BAR_PATH = ['/', '/play', '/library', '/studio'];

export const CHATIE_SERVICE_STATE = {
  serviceName: '채티',
  goodsName: '풍선',
  chatName: '플레이',
};

export const CHEMING_SERVICE_STATE = {
  serviceName: '케밍',
  goodsName: '포션',
  chatName: '',
};

export enum DOMAIN {
  chatie = 'chatie',
  cheming = 'cheming',
}

export const PLAY_OUTLOOK_PAGE_SIZE = 5;

export enum ChatRoomMode {
  Delete = 'delete',
  Edit = 'edit',
  Normal = 'normal',
  Capture = 'capture',
  Story = 'story',
  SnapShot = 'snapshot',
}

export enum RewardType {
  MESSAGE = 'chat_token',
  HIDDEN_FILLING = 'hidden_feeling',
  REPORT = 'report',
  TEMPERATURE = 'temperature',
}

export enum RewardTriggerType {
  CHEMI_STEP_ENTERED = 'chemi_step_entered',
  MESSEGE_COUNT_GTE = 'message_count_gte',
}

export const SEARCH_DEFAULT_SECTION_ID =
  process.env.NEXT_PUBLIC_SEARCH_DEFAULT_SECTION_ID;
